/*
  *******************
      注册全局组件
  *******************
*/
import Vue from 'vue'

import layout from '~/components/layout'
import layoutHeader from '~/components/layout/header'
import layoutContent from '~/components/layout/content'

import contentSidebar from '~/components/layout/content/sidebar'
import contentMain from '~/components/layout/content/main'
import flexclView from '~/components/layout/content/main/flexcl-view.vue'

import viewHeader from '~/components/layout/content/main/view-header.vue'
import viewFooter from '~/components/layout/content/main/view-footer.vue'
import paginationBox from '~/components/layout/content/main/pagination-box.vue'
import borderTitle from '~/components/border-title.vue'

Vue.component('layout', layout)
Vue.component('layoutHeader', layoutHeader)
Vue.component('layoutContent', layoutContent)
Vue.component('contentSidebar', contentSidebar)
Vue.component('contentMain', contentMain)
Vue.component('flexclView', flexclView)

Vue.component('viewHeader', viewHeader)
Vue.component('viewFooter', viewFooter)
Vue.component('paginationBox', paginationBox)
Vue.component('borderTitle', borderTitle)



// WEBPACK FOOTER //
// ./src/utils/components.js